enum ArrowDirection {
    NotDisplayed,
    Open,
    Close
}
export default ArrowDirection;
